import { sendGTMEvent } from '@next/third-parties/google'

export type UserUnicityIdCopiedEventLocationsType =
  | 'profile_menu'
  | 'account_menu'

export const gtmUserUnicityIdCopied = (
  event_location: UserUnicityIdCopiedEventLocationsType,
) => {
  const uuid = crypto.randomUUID()

  sendGTMEvent({
    event: 'sho_user_unicity_id_copied',
    event_location,
    event_id: uuid,
  })
}
